import classNames from 'classnames';
import * as React from 'react';
import { MarkdownPreview } from 'uxp/components';
interface IMarkdownViewProps {
    text: string;
    className?:string
}

const MarkdownView: React.FunctionComponent<IMarkdownViewProps> = (props) => {
    return <MarkdownPreview value={props.text || ''} className={classNames('markdown-view', props.className)} />;
}

export default MarkdownView
